var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "screenshot-name" },
    [
      _c("div", { staticClass: "text-truncate" }, [
        _c(
          "a",
          {
            attrs: { href: "" },
            on: {
              click: function ($event) {
                $event.preventDefault()
                _vm.showScreenshot = true
              },
            },
          },
          [_vm._v(_vm._s(_vm.filename || _vm.value))]
        ),
      ]),
      _vm._v(" "),
      _vm.value
        ? _c("VueEasyLightbox", {
            attrs: { visible: _vm.showScreenshot, imgs: [_vm.value], index: 0 },
            on: {
              hide: function ($event) {
                _vm.showScreenshot = false
              },
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "toolbar",
                  fn: function () {
                    return [_vm._v(" ")]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              616574996
            ),
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }